import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { PMultiCheckboxProps } from '@/components/atoms/MultiCheckbox/types';

/**
 * `PMultiCheckbox` is the design system atom for a list of independently toggleable checkboxes.
 *
 * Accepts `state` for API consistency with the other form-input atoms; `locked` currently renders
 * identically to `disabled` — a checked/unchecked value isn't ambiguous the way a text value is.
 */
export function PMultiCheckbox<T extends string | number>({
  options,
  value,
  onToggle,
  row,
  spacing,
  itemSx,
  state = 'enabled',
}: PMultiCheckboxProps<T>) {
  return (
    <FormGroup
      sx={{
        ...(row && {
          flexDirection: 'row',
        }),
        '& .MuiFormControlLabel-root': {
          '&:not(:last-of-type)': {
            mb: spacing || 0,
          },
          ...(row && {
            mr: 0,
            '&:not(:last-of-type)': {
              mr: spacing || 2,
            },
          }),
        },
      }}
    >
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={value.includes(option.value)}
              onChange={() => onToggle(option.value)}
              disabled={state !== 'enabled'}
            />
          }
          label={option.label}
          sx={itemSx}
        />
      ))}
    </FormGroup>
  );
}
